import { useEffect } from "react";
import { CONFIG } from "../lp/config";
import { PARTNERS } from "../lp/partners";
import "../lp/driver-form.css";
import "./agreements.css";

/** 内容を改定したら更新してください。ページ内に表示されます */
const REVISED = "2026年8月23日";

/**
 * /driver/agreements
 * 利用規約・個人情報の取扱い・提携会社一覧を1ページにまとめています。
 * フォームからはアンカー付きで別タブで開くため、入力途中の内容は失われません。
 */
export default function Agreements() {
  useEffect(() => {
    document.title = "利用規約・個人情報の取扱い・提携会社一覧｜Workful DRIVER";
  }, []);

  // SPA では hash 付きで開いても自動スクロールしないため、自前で合わせます
  useEffect(() => {
    if (!location.hash) return;
    document.querySelector(location.hash)?.scrollIntoView({ behavior: "instant" });
  }, []);

  return (
    <>
      <header className="head">
        <div className="head__row">
          <div className="brand">
            Workful <span>DRIVER</span>
          </div>
        </div>
      </header>

      <main className="doc-main">
        <ul className="toc">
          <li>
            <a href="#terms">利用規約</a>
          </li>
          <li>
            <a href="#privacy">個人情報の取扱い</a>
          </li>
          <li>
            <a href="#partners">提携会社一覧</a>
          </li>
        </ul>

        <Terms />
        <Privacy />
        <Partners />

        <p className="doc-corp">
          {CONFIG.company}
          <br />
          {CONFIG.address}
          <br />
          特定募集情報等提供事業者 届出受理番号 {CONFIG.noticeNo}
        </p>

        <p style={{ textAlign: "center" }}>
          <a className="doc-back" href="/driver">
            登録フォームに戻る
          </a>
        </p>
      </main>
    </>
  );
}

/* ============================================================
   利用規約
   ============================================================ */
function Terms() {
  return (
    <section className="doc-sec" id="terms">
      <h2>利用規約</h2>
      <p className="rev">最終改定日：{REVISED}</p>

      <h3>第1条（適用）</h3>
      <p>
        本規約は、{CONFIG.company}
        （以下「当社」といいます）が提供するドライバー求人の登録サービス「Workful
        DRIVER」（以下「本サービス」といいます）の利用条件を定めるものです。本サービスに登録された方（以下「利用者」といいます）は、本規約に同意のうえ本サービスを利用するものとします。
      </p>

      <h3>第2条（本サービスの内容）</h3>
      <p>
        本サービスは、当社が特定募集情報等提供事業者として、利用者から登録された情報を、利用者の希望条件に対応する提携会社（人材紹介会社・人材派遣会社。以下「提携会社」といいます）に提供し、提携会社から利用者へ求人情報の案内が行われる機会を設けるものです。
      </p>
      <p>
        当社は職業紹介そのものを行うものではなく、雇用契約の締結、労働条件の決定その他の求人に関する手続は、利用者と提携会社または求人企業との間で行われます。
      </p>

      <h3>第3条（利用料金）</h3>
      <p>利用者は、本サービスを無料で利用できます。</p>

      <h3>第4条（登録情報）</h3>
      <ol>
        <li>利用者は、登録にあたり真実かつ正確な情報を入力するものとします。</li>
        <li>
          利用者は、登録情報が提携会社（最大{CONFIG.maxPartners}
          社）へ提供されること、および提携会社から電話・SMS等により連絡が行われることに同意するものとします。提供先は
          <a href="#partners">提携会社一覧</a>に掲載しています。
        </li>
        <li>
          登録情報の内容に変更が生じた場合、または提供の停止を希望する場合は、
          <a href={`mailto:${CONFIG.contactEmail}`}>{CONFIG.contactEmail}</a>
          までご連絡ください。
        </li>
      </ol>

      <h3>第5条（禁止事項）</h3>
      <p>利用者は、本サービスの利用にあたり、次の行為を行ってはなりません。</p>
      <ul>
        <li>虚偽の情報を登録する行為</li>
        <li>他人になりすまして登録する行為、第三者の個人情報を無断で登録する行為</li>
        <li>本サービスの運営を妨げる行為、当社または提携会社の権利を侵害する行為</li>
        <li>法令または公序良俗に反する行為</li>
      </ul>

      <h3>第6条（登録の抹消）</h3>
      <p>
        当社は、利用者が本規約に違反したと判断した場合、事前の通知なく登録情報を削除し、本サービスの利用をお断りすることがあります。
      </p>

      <h3>第7条（免責事項）</h3>
      <ol>
        <li>
          当社は、提携会社から利用者に対して連絡が行われること、求人が紹介されること、および雇用契約が成立することを保証するものではありません。
        </li>
        <li>
          当社は、提携会社または求人企業と利用者との間に生じた紛争について、当社の責めに帰すべき事由がある場合を除き、責任を負いません。
        </li>
        <li>
          当社は、本サービスの提供の中断・停止により利用者に生じた損害について、当社の責めに帰すべき事由がある場合を除き、責任を負いません。
        </li>
      </ol>

      <h3>第8条（本規約の変更）</h3>
      <p>
        当社は、必要と判断した場合、本規約を変更することがあります。変更後の規約は本ページに掲載した時点から効力を生じるものとします。
      </p>

      <h3>第9条（準拠法・管轄）</h3>
      <p>
        本規約は日本法に準拠します。本サービスに関して紛争が生じた場合、名古屋地方裁判所を第一審の専属的合意管轄裁判所とします。
      </p>
    </section>
  );
}

/* ============================================================
   個人情報の取扱い
   ============================================================ */
function Privacy() {
  return (
    <section className="doc-sec" id="privacy">
      <h2>個人情報の取扱い</h2>
      <p className="rev">最終改定日：{REVISED}</p>

      <p>
        {CONFIG.company}
        は、本サービスにおいて取得する個人情報を、個人情報の保護に関する法律および職業安定法その他の関係法令を遵守して取り扱います。
      </p>

      <h3>1. 取得する情報</h3>
      <table>
        <tbody>
          <tr>
            <th>ご入力いただく情報</th>
            <td>
              お名前（姓・名）、携帯電話番号、生年月日、性別、郵便番号または希望就業エリア、免許区分、AT限定の有無、保有資格、就業状況、転職意向、希望条件
            </td>
          </tr>
          <tr>
            <th>自動的に取得する情報</th>
            <td>
              流入元（参照元URL・広告パラメータ）、送信日時、送信元URL、IPアドレス、ブラウザ情報、Cookie等を用いた利用状況
            </td>
          </tr>
        </tbody>
      </table>

      <h3>2. 利用目的</h3>
      <ul>
        <li>提携会社への情報提供および提携会社による求人のご案内のため</li>
        <li>当社からのご連絡、お問い合わせへの対応のため</li>
        <li>本サービスの品質向上、統計分析および広告効果の測定のため</li>
        <li>法令に基づく記録の作成・保存のため</li>
      </ul>

      <h3>3. 第三者提供について</h3>
      <p>
        当社は、ご本人の同意に基づき、登録時にご入力いただいた次の項目を提携会社（最大
        {CONFIG.maxPartners}社）に提供します。
      </p>
      <table>
        <tbody>
          <tr>
            <th>提供する項目</th>
            <td>
              お名前、携帯電話番号、郵便番号（または希望エリア）、免許区分、保有資格、就業状況、希望条件、生年月日、性別
            </td>
          </tr>
          <tr>
            <th>提供の手段</th>
            <td>電子メールによる送信</td>
          </tr>
          <tr>
            <th>提供先</th>
            <td>
              <a href="#partners">提携会社一覧</a>に掲載の各社
            </td>
          </tr>
          <tr>
            <th>提供の停止</th>
            <td>
              ご本人からのお申し出により停止します。
              <a href={`mailto:${CONFIG.contactEmail}`}>{CONFIG.contactEmail}</a>
              までご連絡ください。
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        上記のほか、法令に基づく場合を除き、あらかじめご本人の同意を得ることなく個人情報を第三者に提供することはありません。
      </p>

      <h3>4. 安全管理措置</h3>
      <p>
        当社は、個人情報への不正アクセス、紛失、破壊、改ざんおよび漏えいを防止するため、アクセス権限の限定、通信の暗号化その他の必要かつ適切な措置を講じます。
      </p>

      <h3>5. 保存期間</h3>
      <p>
        利用目的の達成に必要な期間、および職業安定法その他の法令で保存が義務付けられている期間、登録情報を保存します。保存期間の経過後は、遅滞なく消去または匿名化します。
      </p>

      <h3>6. Cookie・アクセス解析について</h3>
      <p>
        本サービスでは、利用状況の把握および広告効果の測定のために Google
        アナリティクスを利用しています。同サービスは Cookie
        により情報を収集しますが、個人を特定する情報は含まれません。ブラウザの設定により
        Cookie を無効にすることができます。
      </p>

      <h3>7. 開示・訂正・利用停止等のご請求</h3>
      <p>
        ご本人（またはその代理人）から、保有個人データの開示、訂正、追加、削除、利用停止、第三者提供の停止のご請求があった場合、ご本人であることを確認のうえ、法令に従い遅滞なく対応します。
      </p>

      <h3>8. お問い合わせ窓口</h3>
      <p>
        {CONFIG.company}　個人情報お問い合わせ窓口
        <br />
        {CONFIG.address}
        <br />
        メール：<a href={`mailto:${CONFIG.contactEmail}`}>{CONFIG.contactEmail}</a>
      </p>
    </section>
  );
}

/* ============================================================
   提携会社一覧
   ============================================================ */
function Partners() {
  return (
    <section className="doc-sec" id="partners">
      <h2>提携会社一覧</h2>
      <p className="rev">最終更新日：{REVISED}</p>

      <p>
        ご登録いただいた情報は、ご希望のエリア・免許区分に対応する次の会社（最大
        {CONFIG.maxPartners}社）に提供されます。各社から求人のご案内のお電話・SMSが届きます。
      </p>

      {PARTNERS.length === 0 ? (
        <p className="note">
          現在、掲載できる提携会社はありません。提携会社が決まり次第、本ページに会社名・許可番号・所在地を掲載します。掲載がない期間は、ご登録いただいた情報を第三者に提供することはありません。
        </p>
      ) : (
        PARTNERS.map((p) => (
          <div className="partner" key={p.name}>
            <p className="partner__name">
              {p.url ? (
                <a href={p.url} target="_blank" rel="noopener noreferrer">
                  {p.name}
                </a>
              ) : (
                p.name
              )}
            </p>
            <dl>
              <dt>許可番号</dt>
              <dd>{p.license}</dd>
              <dt>所在地</dt>
              <dd>{p.address}</dd>
            </dl>
          </div>
        ))
      )}

      <p style={{ marginTop: 16 }}>
        提携会社への提供の停止をご希望の場合は、
        <a href={`mailto:${CONFIG.contactEmail}`}>{CONFIG.contactEmail}</a>
        までご連絡ください。
      </p>
    </section>
  );
}
